import { IsiSubMenuManager } from "./IsiSubMenuManager";
import { getMenuIDFromKey } from "../../menu.ts";
import { IIsiDtoMenuObject, IIsiDtoMenuManagerClientSettings, IIsiDtoMenuManagerClientState } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject";
import { IsiItemList } from "../../IsiItemList";

export class IsiMenuManager {
    /// <summary>
    ///     Classe de gestion des menus.
    /// </summary>

    _settings: IIsiDtoMenuManagerClientSettings;
    _state: IIsiDtoMenuManagerClientState;

    _aOpenedMenu: IsiItemList;
    _mm;
    _md;
    _eMaster;
    _eDetail;
    _menuNeverValideByDesign = { actionCloturerAppel: "actionCloturerAppel", actionClotureTechnique: "actionClotureTechnique" };

    //_entriesById;
    //_entriesIdByClientId;
    //_entriesIdByBarAndKey;

    _subMenuManagers: IsiSubMenuManager[];

    constructor(settings: IIsiDtoMenuManagerClientSettings, state: IIsiDtoMenuManagerClientState) {
        this._settings = settings;
        this._state = state;
        // Menu ouvert
        this._aOpenedMenu = null;
        // menu master
        this._mm = null;
        // menu detail
        this._md = null;

        this._eMaster = MNU_MASTER;
        this._eDetail = MNU_DETAIL;

        this._subMenuManagers = [];

        if (window.iws_StartDetailRowCount) {
            window.iws_StartDetailRowCount(this._settings.tempoCountDetail);
        }

        this.hideMenu();
    }

    /**
     * Cache tout les menus qui doivent être cachée
     */
    private hideMenu() {
        Object.entries(this._settings.menuEntriesById).forEach(([key, value]) => {
            if (value.isVisble === false) {
                this.hide(key, false)
            }
        })
    }

    get subMenuManagers() {
        return this._subMenuManagers;
    }


    //---------------------------------------------------------------
    // Public members
    //---------------------------------------------------------------
    registerOpenedMenu(menuId: string) {
        /// <summary>
        ///     Specifie qu'on ouvre le menu donne.
        /// </summary>
        /// <param name="menuId" type="String">Identifiant du menu ouvert.</param>

        this._init();
        if (!this._aOpenedMenu.Contains(menuId)) {
            this._aOpenedMenu.Add(menuId, "");
        }
        //uiCore.log("registerOpenedMenu : " + menuId + ", nb=" + this._aOpenedMenu.Count());
    }
    /**
     * Indique s'il existe des actions associées à un groupe d'action (mm, md...)
     */
    existActionsBarGroup(barGroupId: string) {
        if (this.entriesIdByBarAndKey[barGroupId]) {
            return true;
        } else {
            return false;
        }
    }
    removeOpenedMenu(menuId: string) {
        /// <summary>
        ///     Specifie qu'on ferme le menu donne.
        /// </summary>
        /// <param name="menuId" type="String">Identifiant du menu ferme.</param>

        this._init();
        if (this._aOpenedMenu.Contains(menuId)) {
            this._aOpenedMenu.Remove(menuId);
        }
        //uiCore.log("removeOpenedMenu : " + menuId + ", nb=" + this._aOpenedMenu.Count());
    }

    existsOpenedMenu() {
        /// <summary>
        ///     Indique s'il existe un menu ouvert.
        /// </summary>
        /// <param name="menuId" type="String">Identifiant du menu ferme.</param>

        this._init();
        return this._aOpenedMenu.Count() > 0;
    }

    getMenuMaster() {
        /// <summary>
        ///     Donne le menu master.
        /// </summary>
        if (this._mm == null) {
            this._mm = document.getElementById(this._eMaster);
        }
        return this._mm;
    }

    getMenuDetail() {
        /// <summary>
        ///     Donne le menu detail.
        /// </summary>
        if (this._md == null) {
            this._md = document.getElementById(this._eDetail);
        }
        return this._md;
    }
    IsValideImplicite(actionId: string) {
        /// <summary>
        ///     Enregistre un menu avec validation implicite
        /// </summary
        /// <history>
        ///		 <entry mat="LBRI" date="11/01/2016" task="DEV116632">Création</entry>
        /// </history>

        if (typeof (this._menuNeverValideByDesign[actionId]) != "undefined") {
            return false;
        } else {
           
            return this._settings.implicitValid.find(function (val) {return val === actionId }) !== undefined;
        }
    }

    dispose() {
        /// <summary>
        ///  Libere la memoire utilisee par les menus.
        /// </summary>
        this._aOpenedMenu = null;
        this._mm = null;
        this._md = null;
        this._menuNeverValideByDesign = null;
    }

    //---------------------------------------------------------------
    // Private members
    //---------------------------------------------------------------
    _init() {
        if (this._aOpenedMenu == null) {
            this._aOpenedMenu = new IsiItemList();
        }
    }
    get entriesById() {
        return this._settings.menuEntriesById;
    }
    get entriesIdByClientId() {
        return this._settings.menuEntriesIdByClientId;
    }
    get entriesIdByBarAndKey() {
        return this._settings.menuEntriesIdByBarAndKey;
    }
    openMenuByEntry(entry: IIsiDtoMenuObject) {
        if (entry && entry.clientIds && entry.clientIds.length > 0) {
            this.openMenuById(entry.clientIds[0]);
        }
    }
    setEntryOption(id: string, option: string) {
        let entry = this.getEntryById(id);
        if (entry) {
            entry.optionUrl = option;
        }
    }
    /**
    * Lance une action du menu
    * @param id id de l'action
    */
    openMenuById(id: string) {
        let entry = this.getEntryById(id);
        screenCore.onClick(entry, id);
    }
    /**
     * Lance une action du menu
     * @param id id de l'action
     * @param event evenement du DOM
     */
    openMenuByIdWithEvent(id: string, event : any) {
        let entry = this.getEntryById(id);
        screenCore.onClick(entry, id, event);
    }

    openMenu(bar: string, group: string, key: string) {
        let id = getMenuIDFromKey(bar, group, key);
        if (!id) {
            id = bar + MNU_SEP + group + MNU_SEP + key;
        }
        let entry = this.getEntryById(id);
        screenCore.onClick(entry, id);
    }
    existMenu(id: string): boolean {
        const entry = this.getEntryById(id);
        if (entry) { return true; } else { return false; }
    }
    getGroupElement(bar: string, group: string) {
        return jQuery("#" + CSS.escape(bar + MNU_SEP + group));
    }
    getEntryByElement(jElement: JQuery) {
        return this.getEntryById(jElement.attr("id"));
    }
    /**
     * Récupere le "menu" avec le filtre jQuery passé en paramètre
     *  retourne l'élément jquery s'il existe
     * @param id
     * @param filter
     */
    _innerGetEntryElementById(id: string, filter: string) {
        var entry;
        var jElement: JQuery;
        var clientIdIndex;
        entry = this.entriesById[id];
        if (entry && entry.clientIds.length) {
            clientIdIndex = 0;
            while (clientIdIndex < entry.clientIds.length && !jElement) {
                jElement = jQuery("#" + CSS.escape(entry.clientIds[clientIdIndex]) + filter);
                if (jElement.length == 0) {
                    jElement = null;
                } 

                clientIdIndex += 1;
            }
            return jElement;
        }
        return null;
    }
    getEntryElementById(id: string) {
        //filtre des actions de la dockedbar
        var filter = "[data-dockid*='IsiButtonBar']";
        //On prend de préférence les actions qui ne sont pas de la dockerbar
        let elem = this._innerGetEntryElementById(id, ":not(" + filter + ")");
        if (elem == null) {
            //sin on pas trouvé alors on tente la dockedbar
            elem = this._innerGetEntryElementById(id, filter);
        }
        return elem;
    }
    getEntryElement(bar: string, group: string, key: string) {
        return this.getEntryElementById(bar + MNU_SEP + group + MNU_SEP + key);
    }
    getEntryElementByBarAndKey(bar: string, key: string) {
        if (this.entriesIdByBarAndKey[bar] && this.entriesIdByBarAndKey[bar][key]) {
            //ARAN 10/01/2019 - ATTENTION : J'ai fait des truc ici, mais je ne maitrise pas les impacts (j'ai signaler que les modif pouvais avoir des impact que je ne maitrisais pas mais RAB à priori).
            //[PB0019214]On retourne l'id de l'élément et non pas l'élément car si les menus n'est pas affiché l'élément n'existe pas.
            //[Dysf86248]En fait il faut renvoyer l'élément car on en a besoin pour les raccourci clavier. Du coup, on tente de récupérer l'élement 
            //si la récupération ne retourne rien on retourne juste l'ID.            
            let id = this.entriesIdByBarAndKey[bar][key];
            let oElem = this.getEntryElementById(id);
            //Si l'élément n'existe pas sur la page, alors on retourne l'ID.
            if (!oElem) {
                let tab = [];
                tab.push({ id: id });
                return tab;
            }
            return oElem;
        }
        return null;
    }
    /**
     * Retourne l'ensemble des menus dont la barre et la clef correspondent
     * Par exemple dans le cas d'un menu avec plusieurs instances d'ajout on 
     * aura plusieurs valeurs.
     * @param bar l'id de la barre
     * @param key l'id de la clef
     * @returns la liste des entrées de menus pour le couple bar & clef.
     */
    getEntryElementsByBarAndKey(bar: string, key: string) {
        const list = new Array<IIsiDtoMenuObject>();
        for (const entryKey  in this.entriesById) {
            const entry = this.entriesById[entryKey];
            if (entry.bar === bar && entry.key === key) {
                list.push(entry);
            }
        }
        return list;
    }
    getEntry(bar: string, group: string, key: string) {
        return this.getEntryById(bar + MNU_SEP + group + MNU_SEP + key);
    }
    getEntryById(id: string) {
        let entry: IIsiDtoMenuObject = this.entriesById[id];
        if (!entry) {
            let newId = this.entriesIdByClientId[id];
            entry = this.entriesById[newId];
        }
        return entry;
    }
    getEntryId(id: string) {
        if (this.entriesById[id]) {
            return id;
        }
        return <string>this.entriesIdByClientId[id];
    }

    setAltValue(id: string, value: string) {
        let entry = this.getEntryById(id);
        if (entry) {
            this._applyMethodOnEntryComponent(entry, "setAltValue", [id, value], false);
        }
    }
    hide(id: string, applyOnMainEntry: boolean) {
        let entry = this.getEntryById(id);
        this._applyMethodOnEntryComponent(entry, "hide", [id], applyOnMainEntry);
    }
    /**
     * Cache une entrée d'action.
     * @param entry
     * @param applyOnMainEntry
     */
    hideEntry(entry: IIsiDtoMenuObject, applyOnMainEntry: boolean) {
        let id = entry.bar + "##" + entry.group + "##" + entry.id;
        this._applyMethodOnEntryComponent(entry, "hide", [id], applyOnMainEntry);
    }
    show(id: string, applyOnMainEntry: boolean) {
        let entry = this.getEntryById(id);
        this._applyMethodOnEntryComponent(entry, "show", [id], applyOnMainEntry);
    }
    setEntryLabel(entry: IIsiDtoMenuObject | string, label: string) {
        var id;
        if (typeof (entry) === "string") {
            id = entry;
            entry = this.getEntryById(id);
        } else {
            id = entry.id;
        }

        if (entry) {
            const args: Array<string> = [];
            args.push(id);
            args.push(label);
            this._applyMethodOnEntryComponent(entry, "setLabel", args, false);
        }
    }
    _applyMethodOnEntryComponent(entry: IIsiDtoMenuObject, method: string, args, applyOnMainEntry: boolean) {
        var component;
        var func;
     
        let entriesId = [];

        if (entry !== undefined) {
            if (applyOnMainEntry) {
                entriesId.push(args[0]);
            } else {
                entriesId = entry.clientIds;
            }
            jQuery.each(entriesId, (i, id) => {
                component = uiCore.componentManager.getParentComponentFromHtmlChildId(id);
                if (component) {
                    func = component[method];
                    if (func) {
                        args[0] = id;
                        func.apply(component, args);
                    }
                } else {
                    this._applyMethodOnEntryJElements(id,method,args);
                }
            });
        }
    }
    /**
     * Essaye d'appliqué la méthode sur les éléments jQuery correspondant i.e. soit id = id soit data-value = id.
     * @param id
     * @param method
     * @param args
     */
    _applyMethodOnEntryJElements(id: string, method: string, args) {
        var func;
      
        let jElements = jQuery("#" + CSS.escape(id));
        jElements.each((j, element) =>{
            var jElement;
            jElement = jQuery(element);
            func = this._getJQueryElementMethod(jElement, method);
            if (func) {
                func.apply(jElement, args);
            } else {
                func = jElement[method];
                if (func) {
                    func.apply(jElement, {});
                }
            }
        });
    }
    _getJQueryElementMethod(jElement: JQuery, method: string) {
        var func;
        var isButton;

        isButton = jElement.hasClass("iButton") || jElement.hasClass("iButtonInactif");
        switch (method) {
            case "setAltValue":
                if (isButton) {
                    func = function (id, value) {
                        //HGAN 25/05/2021 [PB0021746] - Le compteur sur la donnée associée "Actions" n'était pas visible pour les dossiers clos.
                        if (value && this.data("menuid") !== undefined) {
                            if (this.data("menuid").indexOf("#DATA_ADD_ITEM#") >= 0) {
                                //btn.value = btn.value;
                            }
                            else {
                                let label = this.val();
                                if (label.indexOf("(") > 0) {
                                    label = label.substr(0, label.indexOf("(") - 1);
                                }
                                this.val(label + " (" + value + ")");
                            }
                        } else {
                            let label = this.val();
                            if (label.indexOf("(") > 0) {
                                this.val(label.substr(0, label.indexOf("(") - 1));
                            }
                        }
                    };
                }
                break;

            case "setLabel":
                if (isButton) {
                    func = function (id, value) {
                        this.val(value);
                    };
                }
                break;
        }

        return func;
    }/*,
    setBtnAltValue: function (id, value) {
        /// <summary>
        ///  Affiche le nombre d'enregistrement sur un bouton associé à une DA.
        /// </summary>

        var iPos = mnuDetailName.indexOf("##");
        if (iPos > -1) {
            var sName = mnuDetailName.substring(iPos);
            var myBtn = jQuery("input[type='button'][onclick*='Menu_BeforeItemSelected'][onclick*='" + sName + "']");

            if (myBtn) {
                var btn;
                /// ABON 72937 il faut le faire pour chaque element retourne par jQuery sinon c'est pas bon
                for (var i = 0; i < myBtn.length; i++) {
                    btn = myBtn[i];
                    if (btn.outerHTML.indexOf("#DATA_ADD_ITEM#") >= 0)
                    { btn.value = btn.value; }
                    else
                    { btn.value = btn.value + " (" + txt + ")"; }
                }
            }
        }
    }*/
}

window.IsiMenuManager = IsiMenuManager;
